/** In-page anchor for the Help Center support form aside / dialog. */
export const HELP_SUPPORT_FORM_ID = 'help-support-form';

/** FAQ block on `/help` — pairs with per-item `faq-{id}` ids in `Faq`. */
export const HELP_FAQ_SECTION_ID = 'help-faq';

export const HELP_SUPPORT_HASH = `#${HELP_SUPPORT_FORM_ID}`;

export function helpFaqItemId(faqId: string): string {
  return `faq-${faqId}`;
}
